module.exports = __webpack_public_path__ + "img/2.480ed794.jpg";